// db/index.ts
import "./a-user.js";
import "./a-roles.js";
import "./currentUserInfo.js";
